import React, { Component } from 'react';


import { Form, Input, Button, Modal, InputNumber } from 'antd';
const FormItem = Form.Item;

class CamdetectParkinglocationsSettingsForm extends Component {

    state = {
        modalVisible: false
    }

    form = null;

    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSuccess(this.props.form, values);
            }
        });
    }

    renderForm() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Kapacita parkoviště" >
                    {getFieldDecorator('totalCapacity', {
                        initialValue: this.props.initialValues && this.props.initialValues.totalCapacity
                            ? this.props.initialValues.totalCapacity
                            : null,
                        rules: [{
                            type: 'number', message: 'Položka musí obsahovat číslo!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <InputNumber min={1} max={999999} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Zpoždění před odesílání" >
                    {getFieldDecorator('delayPublishOcc', {
                        initialValue: this.props.initialValues && this.props.initialValues.delayPublishOcc !== null
                            ? this.props.initialValues.delayPublishOcc
                            : null,
                        rules: [{
                            type: 'number', message: 'Položka musí obsahovat číslo!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <InputNumber min={0} max={999999} />
                    )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">Uložit</Button>
                </FormItem>
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={650}
                    title="Nastavení lokality"
                    visible={this.state.modalVisible}
                    maskClosable={false}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedCamdetectParkinglocationSettingForm = Form.create()(CamdetectParkinglocationsSettingsForm);

export default WrappedCamdetectParkinglocationSettingForm;


// WEBPACK FOOTER //
// ./src/components/CamdetectParkinglocationSettingsForm.js